// Stratz-style analysis configuration and constants

// All 8 brackets for win rate lookup
export const BRACKETS = [
    'Herald',
    'Guardian',
    'Crusader',
    'Archon',
    'Legend',
    'Ancient',
    'Divine',
    'Immortal'
];

// Bracket groups for synergy/counter lookup
// Maps individual brackets to their grouped bracket for synergy data
export const BRACKET_GROUPS = {
    'Herald': 'Herald_Guardian',
    'Guardian': 'Herald_Guardian',
    'Crusader': 'Crusader_Archon',
    'Archon': 'Crusader_Archon',
    'Legend': 'Legend_Ancient',
    'Ancient': 'Legend_Ancient',
    'Divine': 'Divine_Immortal',
    'Immortal': 'Divine_Immortal'
};

// Position labels
export const POSITIONS = [
    { id: 1, label: 'Pos 1', name: 'Carry' },
    { id: 2, label: 'Pos 2', name: 'Mid' },
    { id: 3, label: 'Pos 3', name: 'Offlane' },
    { id: 4, label: 'Pos 4', name: 'Soft Support' },
    { id: 5, label: 'Pos 5', name: 'Hard Support' }
];

// S3 configuration for stratz-style data
export const STRATZ_DATA_CONFIG = {
    bucketUrl: 'https://draftdiff.s3.amazonaws.com',
    filename: 'public/stratz_data.json.gz'
};

// Default bracket selection
export const DEFAULT_BRACKET = 'Archon';

// Pick rate threshold options (in percentages)
export const PICK_RATE_THRESHOLDS = [
    { value: 0, label: '0%' },
    { value: 0.5, label: '0.5%' },
    { value: 1, label: '1%' },
    { value: 2, label: '2%' },
    { value: 3, label: '3%' },
    { value: 4, label: '4%' },
    { value: 5, label: '5%' },
    { value: 6, label: '6%' },
    { value: 7, label: '7%' },
    { value: 8, label: '8%' },
    { value: 9, label: '9%' },        
    { value: 10, label: '10%' },
    { value: 12, label: '12%' },
    { value: 14, label: '14%' },
    { value: 16, label: '16%' },
    { value: 18, label: '18%' },
    { value: 20, label: '20%' },
    { value: 25, label: '25%' },
    { value: 30, label: '30%' },
    { value: 35, label: '35%' },
    { value: 40, label: '40%' },
    { value: 50, label: '50%' }    
];

// Default pick rate thresholds
export const DEFAULT_HERO_PICK_RATE = 0;
export const DEFAULT_POSITION_PICK_RATE = 0;

/**
 * Get the bracket group for synergy/counter lookups
 * @param {string} bracket - Individual bracket name
 * @returns {string} - Bracket group name for synergy data
 */
export function getBracketGroup(bracket) {
    return BRACKET_GROUPS[bracket] || 'Crusader_Archon';
}

/**
 * Data structure reference (for documentation):
 *
 * {
 *   "metadata": {
 *     "generated_at": "2025-11-17T...",
 *     "time_range_days": 7
 *   },
 *   "win_rates": {
 *     "Herald": {
 *       "position_1": [{"hero": "Anti-Mage", "winrate": 0.52, "matches": 1500}, ...],
 *       "position_2": [...],
 *       "position_3": [...],
 *       "position_4": [...],
 *       "position_5": [...]
 *     },
 *     // ... all 8 brackets
 *   },
 *   "synergies_counters": {
 *     "Herald_Guardian": {
 *       "Anti-Mage": {
 *         "Medusa": {"synergy": 2.5, "counter": -3.2, "matches_with": 150, "matches_vs": 200},
 *         // ... all hero pairs
 *       },
 *       // ... all heroes
 *     },
 *     // ... all 4 grouped brackets
 *   }
 * }
 */
